module.exports = __webpack_public_path__ + "img/0Q3B8222_BlackMatted.68cc2a19.jpg";